import { standards } from './standards';
import { FontAwesomeIconName } from './fontAwesomeIcons';
import {
  APIEntityType,
  AssetType,
  UseCaseSpecificAssetType,
} from '@ardoq/api-types';

export enum SvgArrowName {
  BOTH = 'svg_sprite_arrow_both',
  BOTH_FILLED = 'svg_sprite_arrow_both_filled',
  BOTH_OUTLINED = 'svg_sprite_arrow_both_outlined',
  BOTTOM = 'svg_sprite_arrow_bottom',
  CIRCLE = 'svg_sprite_arrow_circle',
  DEFAULT = 'svg_sprite_arrow_default',
  DIAMOND_FILLED = 'svg_sprite_arrow_diamond_filled',
  DIAMOND_OUTLINED = 'svg_sprite_arrow_diamond_outlined',
  MANY = 'svg_sprite_arrow_many',
  ONE = 'svg_sprite_arrow_one',
  ONE_MANDATORY = 'svg_sprite_arrow_one_mandatory',
  ONE_OR_MANY = 'svg_sprite_arrow_one_or_many',
  TOP = 'svg_sprite_arrow_top',
  ZERO_OR_MANY = 'svg_sprite_arrow_zero_or_many',
  ZERO_OR_ONE = 'svg_sprite_arrow_zero_or_one',
}

export enum SvgImageName {
  ARDOQ_LOGO = 'svg_sprite_ardoq_logo',
  ARDOQ_LOGO_WITH_NAME = 'svg_sprite_ardoq_logo_with_name',
  ARDOQ_LOGO_MONO_WITH_NAME = 'svg_sprite_ardoq_logo_mono_with_name',
  ARDOQ_DISCOVER_LOGO_WITH_NAME = 'svg_sprite_ardoq_discover_logo_with_name',
  BOTTOM_RIGHT_CORNER_FRAME = 'svg_sprite_bottom_right_corner_frame',
  INVERTED_ARDOQ_LOGO = 'svg_sprite_inverted_ardoq_logo',
  SIMPLE_BLOCK_DIAGRAM = 'svg_sprite_simple_block_diagram',
  BLOCKS = 'svg_sprite_blocks',
  TIMELINE = 'svg_sprite_timeline',
  NETWORK = 'svg_sprite_network',
  DEPENDENCY_MAP = 'svg_sprite_dependency_map',
  BUBBLE = 'svg_sprite_bubbles',
  COMPONENT_MATRIX = 'svg_sprite_component_matrix',
}

export enum IconSize {
  EXTRA_SMALL = 13,
  SMALL = 16,
  MEDIUM = 20,
  LARGE = 24,
}

export enum IconName {
  ACCOUNT_TREE = 'remix_node-tree',
  ADD = 'remix_add-line',
  AGENT = 'svg_sprite_agent',
  ADD_CIRCLE = 'remix_add-circle-line',
  AFTER = 'remix_skip-right-line',
  ARCHIVE = 'remix_inbox-archive-line',
  ARROW_BACK = 'remix_arrow-left-line',
  ARROW_DOWN = 'remix_arrow-drop-down-line',
  ARROW_DOWNWARD = 'remix_arrow-down-line',
  ARROW_FORWARD = 'remix_arrow-right-line',
  ARROW_RIGHT = 'remix_arrow-drop-right-line',
  ARROW_UP = 'remix_arrow-drop-up-line',
  ARROW_UPWARD = 'remix_arrow-up-line',
  ATTACHMENT = 'svg_sprite_attachment',
  BLUR_ON = 'svg_sprite_blur_on',
  BLUR_OFF = 'svg_sprite_blur_off',
  BOOKMARK = 'remix_bookmark-line',
  BUBBLE_CHART = 'remix_bubble-chart-line',
  CHECK_MARK = 'remix_check-line',
  CLOSE = 'remix_close-line',
  COLLAPSE_ALL = 'remix_collapse-diagonal-2-line',
  CLOUD_DOWNLOAD = 'remix_download-cloud-2-line',
  COLLECTIONS = 'svg_sprite_collections',
  COMMENT = 'remix_chat-4-line',
  COMPONENT = 'remix_shapes-line',
  COMPUTER = 'svg_sprite_computer',
  CONTAINER = 'remix_square-line',
  DELETE = 'remix_delete-bin-line',
  DESCRIPTION = 'remix_file-text-line',
  DRAG_INDICATOR = 'remix_draggable',
  EDIT = 'remix_edit-line',
  EVENT = 'remix_calendar-event-line',
  EXIT_TO_APP = 'remix_logout-box-line',
  EXPORT = 'remix_export-line',
  EXTENSION = 'remix_puzzle-2-line',
  FIBER_MANUAL_RECORD = 'remix_circle-fill',
  FILE = 'remix_file-fill',
  FILE_COPY = 'remix_file-copy-2-line',
  FILTER_LIST = 'remix_filter-3-line',
  FOLDER = 'remix_folder-2-line',
  FORMAT_LIST_BULLETED = 'remix_list-unordered',
  FORMAT_LIST_NUMBERED = 'remix_list-ordered',
  FORMAT_SIZE = 'remix_font-size',
  FULLSCREEN = 'remix_fullscreen-line',
  FULLSCREEN_EXIT = 'remix_fullscreen-exit-line',
  GRID_ON = 'remix_grid-line',
  HELP = 'remix_question-line',
  INFO = 'remix_information-2-line',
  KNOWLEDGE_BASE = 'remix_questionnaire-line',
  LINE_CHART = 'remix_line-chart-line',
  TABLE_CHART = 'remix_table-line',
  LOCK = 'remix_lock-line',
  LOCK_OPEN = 'remix_lock-unlock-line',
  MAIL = 'remix_mail-line',
  MORE_HORIZ = 'remix_more-fill',
  MORE_VERT = 'remix_more-2-fill',
  NONE = '',
  NOT_INTERESTED = 'remix_forbid-line',
  NOTIFICATIONS = 'remix_notification-2-line',
  NOTIFICATIONS_FILLED = 'remix_notification-2-fill',
  EXPAND_ALL = 'remix_expand-diagonal-2-line',
  OPEN_IN_NEW = 'remix_external-link-line',
  PALETTE = 'remix_palette-line',
  PERSON = 'remix_user-3-line',
  USER_SETTINGS = 'remix_user-settings-line',
  PRIORITY_HIGH = 'svg_sprite_priority_high',
  REFERENCE = 'svg_sprite_reference',
  REFRESH = 'remix_refresh-line',
  REMOVE = 'remix_subtract-line',
  SAVE = 'remix_save-line',
  SEARCH = 'remix_search-line',
  SETTINGS = 'remix_settings-5-line',
  SIGMA = 'remix_functions',
  SORT = 'svg_sprite_sort',
  SPACE_BAR = 'remix_space',
  UNFOLD_LESS = 'remix_contract-up-down-line',
  UNFOLD_MORE = 'remix_expand-up-down-line',
  UPDATE = 'svg_sprite_update',
  VERTICAL_ALIGN_BOTTOM = 'remix_align-bottom',
  VIEW_ARRAY = 'svg_sprite_view_array',
  VIEW_COMPACT = 'svg_sprite_view_compact',
  ORIENTATION_HORIZONTAL = 'svg_sprite_orientation_horizontal',
  VISIBILITY = 'remix_eye-line',
  VISIBILITY_OFF = 'remix_eye-off-line',
  ZOOM_IN = 'remix_zoom-in-line',
  ZOOM_OUT = 'remix_zoom-out-line',
  ZOOM_OUT_MAP = 'remix_expand-diagonal-line',
  CHEVRON_UP = 'remix_arrow-up-s-line',
  CHEVRON_DOWN = 'remix_arrow-down-s-line',
  CHEVRON_LEFT = 'remix_arrow-left-s-line',
  CHEVRON_RIGHT = 'remix_arrow-right-s-line',
  ROTATE_90_DEG = 'remix_anticlockwise-line',

  // SVG SPRITE ICONS
  ADD_CHART = 'svg_sprite_add_chart',
  ADD_LINK = 'svg_sprite_add_link',
  ADD_HEADER = 'remix_heading',
  ADD_NOTE = 'remix_file-add-line',
  ADD_PRESENTATION = 'svg_sprite_add_presentation',
  DATASET = 'remix_connector-line',
  AI_STAR = 'svg_sprite_ai_star',
  AI_ADD_CHART = 'svg_sprite_ai_add_chart',
  AI_ADD_PRESENTATION = 'svg_sprite_ai_add_presentation',
  AI_EDIT = 'svg_sprite_ai_edit',
  AI_FILE = 'svg_sprite_ai_file',
  AI_LIGHTBULB = 'svg_sprite_ai_lightbulb',
  AI_PERSON = 'svg_sprite_ai_person',
  AI_SEARCH = 'svg_sprite_ai_search',
  AI_SYNC = 'svg_sprite_ai_sync',
  AI_TEXT = 'svg_sprite_ai_text',
  AI_IMAGE = 'remix_image-ai-line',
  ALARM_CANCELLED = 'svg_sprite_alarm_cancelled',
  ALARM_ERROR = 'svg_sprite_alarm_error',
  ALARM_SENT = 'svg_sprite_alarm_sent',
  ALARM_TO_BE_SENT = 'svg_sprite_alarm_to_be_sent',
  ANALYTICS = 'remix_lightbulb-flash-line',
  ANIMATION_PAUSE = 'svg_sprite_animation_pause',
  ANIMATION_PLAY = 'svg_sprite_animation_play',
  API = 'svg_sprite_api',
  APPLICATION = 'svg_sprite_application',
  APPLICATION_GROUP = 'svg_sprite_application_group',
  APPLICATION_MODULE = 'svg_sprite_application_module',
  ARCHITECTURE_STANDARD = 'svg_sprite_architecture_standard',
  ARROW_RIGHT_ALT = 'remix_arrow-right-long-line',
  ARROW_RIGHT_LONG = 'svg_sprite_arrow_right_long',
  ARROW_TOP_ALT = 'remix_arrow-up-long-line',
  ARROWS_H = 'remix_expand-horizontal-line',
  ARROWS_H_SHRINK = 'remix_collapse-horizontal-line',
  ACCESS_MANAGEMENT = 'svg_sprite_access_management',
  AT = 'remix_at-line',
  BAR_CHART = 'remix_bar-chart-line',
  BETA = 'svg_sprite_beta',
  BROADCAST = 'remix_broadcast-line',
  BROADCAST_PLACEHOLDER = 'svg_sprite_broadcast_placeholder',
  BROKEN_IMAGE = 'svg_sprite_broken_image',
  BULLSEYE = 'remix_focus-2-line',
  BUSINESS_CAPABILITY = 'svg_sprite_business_capability',
  BUSINESS_HEALTH_CHECK = 'svg_sprite_business_health_check',
  CALCULATOR = 'remix_calculator-line',
  CALENDAR = 'remix_calendar-line',
  CAPABILITY_DELTA = 'svg_sprite_capability_delta',
  CATEGORY = 'svg_sprite_category',
  CHANNEL = 'svg_sprite_channel',
  CHECKBOX_CHECKED = 'remix_checkbox-fill',
  CHECKBOX_ITEM = 'svg_sprite_checkbox_item',
  CHECKBOX_MIXED = 'remix_checkbox-indeterminate-fill',
  CHECKBOX_UNCHECKED = 'remix_checkbox-blank-line',
  CHECKBOX_UNSET = 'svg_sprite_checkbox_unset',
  CHECK_CIRCLE = 'remix_checkbox-circle-line',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  CIRCLE = 'remix_circle-fill',
  CIRCLE_EMPTY = 'remix_circle-line',
  CODE = 'remix_code-line',
  CODE_BLOCK = 'remix_code-block',
  COLLAPSE_GROUPS = 'svg_sprite_collapse_groups',
  COMPLIANCE_ASSESSMENT = 'svg_sprite_compliance_assessment',
  CONDITIONAL = 'svg_sprite_conditional',
  CROSSHAIRS = 'remix_focus-3-line',
  CONTRACT = 'svg_sprite_contract',
  CONTROL = 'svg_sprite_control',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  COPY = 'remix_file-copy-2-line',
  CUBE = 'svg_sprite_cube',
  CUBES = 'svg_sprite_cubes',
  CUSTOMER_SEGMENT = 'svg_sprite_customer_segment',
  DASHBOARD = 'remix_dashboard-line',
  DATE = 'svg_sprite_date',
  DATE_TIME = 'svg_sprite_date_time',
  DATABASE_SEARCH = 'svg_sprite_database_search',
  DATA_ENTITY = 'svg_sprite_data_entity',
  DATA_STORE = 'svg_sprite_data_store',
  DEBT_ITEM = 'svg_sprite_debt_item',
  DECISION_RECORD = 'svg_sprite_decision_record',
  DESIGN_OBJECT = 'svg_sprite_design_object',
  DESCRIPTION_OUTLINED = 'svg_sprite_description_outlined',
  DIFF = 'svg_sprite_diff',
  DIFF_EMPTY = 'svg_sprite_diff_empty',
  DIGITAL_CHANNEL = 'svg_sprite_digital_channel',
  DIGITAL_PRODUCT = 'svg_sprite_digital_product',
  DONUT_CHART = 'remix_donut-chart-line',
  DUPLICATE = 'svg_sprite_duplicate',
  EDGE_BUNDLING = 'svg_sprite_edge_bundling',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ERROR = 'remix_error-warning-line',
  EXCEPTION_REQUEST = 'svg_sprite_exception_request',
  EXTERNALLY_MANAGED = 'svg_sprite_externally_managed',
  EXTERNALLY_MISSING = 'svg_sprite_externally_missing',
  FIELD = 'svg_sprite_field',
  FILE_OUTLINED = 'remix_file-line',
  FILE_UPLOADED = 'remix_file-upload-line',
  FLIP_HORIZONTALLY = 'remix_flip-horizontal-line',
  FLIP_VERTICALLY = 'remix_flip-vertical-line',
  FORMAT_BOLD = 'remix_bold',
  FORMAT_ITALIC = 'remix_italic',
  FORMAT_QUOTE = 'remix_double-quotes-l',
  FOUR_SQUARE_GRID = 'svg_sprite_four_square_grid',
  FOUR_SQUARE_TOP_LEFT = 'svg_sprite_four_square_top_left',
  FOUR_SQUARE_TOP_RIGHT = 'svg_sprite_four_square_top_right',
  FOUR_SQUARE_BOTTOM_LEFT = 'svg_sprite_four_square_bottom_left',
  FOUR_SQUARE_BOTTOM_RIGHT = 'svg_sprite_four_square_bottom_right',
  FUTURE_STATE = 'svg_sprite_future_state',
  GITHUB = 'remix_github-fill',
  GLOBE = 'svg_sprite_globe',
  GLOBE_DISABLED = 'svg_sprite_globe_disabled',
  GOOGLE = 'remix_google-fill',
  HIDE_COMPONENT = 'svg_sprite_hide_component',
  HISTORY = 'remix_history-line',
  HOME = 'remix_home-5-line',
  INCLUDE_REFERENCE_PARENTS = 'svg_sprite_include_reference_parents',
  INFORMATION_ARTIFACT = 'svg_sprite_information_artifact',
  INITIATIVE = 'svg_sprite_initiative',
  TRANSFORMATION_INITIATIVE = 'svg_sprite_transformation_initiative',
  INTEGRATION = 'svg_sprite_integration',
  INTERFACE = 'svg_sprite_interface',
  INVENTORY = 'remix_archive-line',
  KEY = 'remix_key-line',
  KEY_RESULT = 'svg_sprite_key_result',
  LABEL_OUTLINED = 'svg_sprite_label_outlined',
  LANGUAGE = 'svg_sprite_language',
  LAYOUT_SETTINGS = 'svg_sprite_layout_settings',
  LEVEL_DOWN = 'remix_corner-down-right-line',
  LEVEL_LEFT = 'remix_corner-down-left-line',
  LINK = 'remix_link',
  LIST = 'remix_list-view',
  LOCATION = 'svg_sprite_location',
  LOG_OUT = 'remix_logout-box-r-line',
  LUCIDCHART = 'svg_sprite_lucidchart',
  MANAGED_WORKSPACE = 'svg_sprite_managed_workspace',
  MARKET = 'svg_sprite_market',
  MASTER = 'svg_sprite_master',
  MENU = 'remix_menu-line',
  MESSAGE_FORMAT = 'svg_sprite_message_format',
  METAMODEL = 'svg_sprite_metamodel',
  METRIC = 'svg_sprite_metric',
  MISC = 'svg_sprite_misc',
  MOON = 'remix_moon-line',
  NAVIGATE = 'remix_compass-3-line',
  NETWORK_ZONE = 'svg_sprite_network_zone',
  NEW = 'svg_sprite_new',
  NEW_TEXT = 'remix_edit-box-line',
  NODE = 'svg_sprite_node',
  NODE_DISTANCE = 'svg_sprite_node_distance',
  FORMAT_COLOR_RESET = 'remix_blur-off-line',
  NUMBER = 'svg_sprite_number',
  OBJECTIVE = 'svg_sprite_objective',
  OPEN_LINK = 'remix_arrow-right-up-long-line',
  OPENED_FOLDER = 'remix_folder-open-line',
  OPTIMIZE_LAYOUT = 'svg_sprite_optimize_layout',
  ORGANIZATION = 'svg_sprite_organization',
  ORGANIZATIONAL_UNIT = 'svg_sprite_organizational_unit',
  ORIENTATION_VERTICAL = 'svg_sprite_vertical',
  PAINT_BRUSH = 'remix_paint-brush-line',
  PARENT_CHILD = 'svg_sprite_parent_child',
  PASTE = 'remix_clipboard-line',
  PATH = 'remix_route-line',
  PATTERN = 'svg_sprite_pattern',
  PEOPLE = 'remix_group-3-line',
  PERSONA = 'svg_sprite_persona',
  PERSON_UC = 'svg_sprite_person_uc',
  PIE_CHART_FILLED = 'remix_pie-chart-line',
  PIN = 'remix_pushpin-fill',
  PIN_OUTLINE = 'remix_pushpin-line',
  PLUS_ONE = 'svg_sprite_plus_one',
  POWER_BI = 'svg_sprite_power_bi',
  PRESENTATION = 'remix_slideshow-3-line',
  PROCESS = 'svg_sprite_process',
  PROCESS_ACTIVITY = 'svg_sprite_process_activity',
  PRODUCT = 'svg_sprite_product',
  PRODUCT_UPDATES = 'svg_sprite_product_updates',
  RADIO_SELECTED = 'remix_radio-button-line',
  RADIO_UNSELECTED = 'remix_checkbox-blank-circle-line',
  RANDOM = 'svg_sprite_random',
  REDO = 'remix_arrow-go-forward-line',
  REFERENCE_TYPE = 'svg_sprite_reference_type',
  REQUIREMENT = 'svg_sprite_requirement',
  RHOMBUS = 'svg_sprite_rhombus',
  RISK = 'svg_sprite_risk',
  ROCKET = 'remix_rocket-2-line',
  ROLE = 'svg_sprite_role',
  ROLE_ADMIN = 'svg_sprite_permission_admin',
  ROTATE = 'remix_clockwise-line',
  SCENARIO = 'svg_sprite_scenario',
  SCENARIO_MERGE = 'svg_sprite_scenario_merge',
  SELECT_LIST = 'remix_dropdown-list',
  SEPARATE_REFERENCES = 'svg_sprite_separate_references',
  SERVER = 'svg_sprite_server',
  SHIFTX = 'svg_sprite_shiftx',
  SHOW_COMPONENT = 'svg_sprite_show_component',
  SITEMAP = 'remix_organization-chart',
  SORT_ASC = 'remix_sort-asc',
  SPACE_BAR_CROSSED = 'svg_sprite_space_bar_crossed',
  SPARKLES = 'remix_sparkling-2-line',
  SPINNER = 'spinner',
  SPLIT_SCREEN = 'svg_sprite_split_screen',
  SQUARE = 'remix_square-fill',
  SSO = 'svg_sprite_sso',
  STACKED_BAR_CHART = 'remix_stacked-chart-line',
  STAR = 'remix_star-fill',
  STAR_BORDER = 'remix_star-line',
  STRATEGY = 'svg_sprite_strategy',
  STRIKETHROUGH = 'remix_strikethrough',
  SUBJECT_AREA = 'svg_sprite_subject_area',
  SUN = 'remix_sun-line',
  SURVEYS = 'remix_survey-line',
  SWAP_HORIZONTAL = 'remix_arrow-left-right-line',
  SWITCH_CENTER = 'svg_sprite_switch_center',
  SYNC = 'remix_loop-left-line',
  TABLE_COLUMNS = 'remix_layout-column-line',
  TABLE_ROWS = 'remix_layout-row-line',
  TAG = 'remix_price-tag-3-line',
  TAG_OFF = 'svg_sprite_tag_off',
  TECHNICAL_CAPABILITY = 'svg_sprite_technical_capability',
  TECHNOLOGY_HEALTH_CHECK = 'svg_sprite_technology_health_check',
  TECHNOLOGY_PRODUCT = 'svg_sprite_technology_product',
  TECHNOLOGY_SERVICE = 'svg_sprite_technology_service',
  TEXT_AREA = 'remix_text-block',
  TEXT_FORMAT = 'remix_font-color',
  THUMB_DOWN = 'remix_thumb-down-line',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  THUMB_DOWN_OUTLINE = 'remix_thumb-down-line',
  THUMB_UP = 'remix_thumb-up-line',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  THUMB_UP_OUTLINE = 'remix_thumb-up-line',
  TIME = 'remix_time-line',
  TODAY = 'svg_sprite_today',
  TRANSFORMATION_FUTURE_STATE = 'svg_sprite_transformation_future_state',
  TRANSPARENT = 'svg_sprite_transparent',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  TREE_STRUCTURE = 'remix_node-tree',
  TROPHY = 'remix_trophy-line',
  TUNE_SETTINGS = 'remix_equalizer-line',
  UNDO = 'remix_arrow-go-back-line',
  UNPIN_OUTLINE = 'remix_unpin-line',
  URL = 'remix_links-line',
  VALUE_PROP = 'svg_sprite_value_prop',
  VALUE_STREAM = 'svg_sprite_value_stream',
  VALUE_STREAM_STAGE = 'svg_sprite_value_stream_stage',
  VIEW_INFERENCE = 'svg_sprite_view_inference',
  VIEWPOINT = 'svg_sprite_viewpoint',
  VULNERABILITY = 'svg_sprite_vulnerability',
  WARNING = 'remix_alert-line',
  WINDOW_FLOATING = 'svg_sprite_window_floating',
  WINDOW_FULLSCREEN = 'svg_sprite_window_fullscreen',
  WINDOW_SIDEBAR = 'svg_sprite_window_sidebar',
  WORKSPACE = 'svg_sprite_workspace',
  WORKSPACE_DEFINITION = 'svg_sprite_workspace_definition',
  ZOOM_TO_FIT = 'svg_sprite_zoom_to_fit',
  TEXT_COMPARE = 'svg_sprite_text_compare',
  FLOWSHEET = 'svg_sprite_flowsheet',
  HIGHLIGHT = 'remix_mark-pen-line',
  SPEECH_BUBBLE = 'remix_chat-quote-line',
  PERCENTAGE = 'remix_percent-line',

  CUSTOMER_SERVICE = 'remix_customer-service-2-line',
  DETAILS = 'remix_file-info-line',
  SIDEBAR_CLOSE = 'remix_sidebar-fold-line',
  SIDEBAR_OPEN = 'remix_sidebar-unfold-line',
  REPORTS = 'remix_file-list-line',
  SOLUTIONS = 'remix_shield-star-line',
  MY_TASKS = 'remix_list-check-3',
  MY_ACCOUNT = 'remix_equalizer-3-line',
  ADMIN = 'remix_settings-4-line',
  FOLDER_LINE = 'remix_folder-line',
  PRODUCT_PORTAL = 'remix_book-marked-line',
  VIDEO_TUTORIALS = 'remix_play-circle-line',
  NOTIFICATIONS_WITH_DOT = 'svg_sprite_notifications_with_dot',

  ACCESS_READ = 'remix_book-open-line',
  ACCESS_SERVICE_ACCOUNT = 'remix_shield-keyhole-line',
}

export enum CheckboxIconName {
  CHECKED = 'remix_checkbox-fill',
  PARTIALLY_CHECKED = 'remix_checkbox-indeterminate-fill',
  UNCHECKED = 'remix_checkbox-blank-line',
  UNSET = 'svg_sprite_checkbox_unset',
}

export enum ChevronIconName {
  UP = 'remix_arrow-up-s-line',
  DOWN = 'remix_arrow-down-s-line',
  LEFT = 'remix_arrow-left-s-line',
  RIGHT = 'remix_arrow-right-s-line',
}

export enum ColorIconName {
  VISUAL_DIFF_ADDED = 'rgb(151, 240, 170)',
  VISUAL_DIFF_CHANGED = 'rgb(93, 197, 252)',
  VISUAL_DIFF_REMOVED = 'rgb(254, 118, 122)',
  VISUAL_DIFF_UNCHANGED = 'rgb(207, 218, 232)',
}

export type InternalIconName =
  | CheckboxIconName
  | ChevronIconName
  | ColorIconName;

export type IconProps = {
  iconName?:
    | IconName
    | InternalIconName
    | ShapeType
    | SvgImageName
    | StandardsSvgIcon;
  color?: string;
  src?: string;
  iconSize?: IconSize;
  isFocused?: boolean;
  /** @deprecated Icons should not have click handlers. Use IconButton instead. */
  deprecated_onClick?: React.MouseEventHandler<HTMLElement>;
} & Omit<React.HTMLProps<HTMLElement>, 'onClick'>;

export type MinimalIconProps = {
  name: IconProps['iconName'];
  color?: IconProps['color'];
};

export type AiIconName = (typeof IconName)[Extract<
  keyof typeof IconName,
  `AI_${string}`
>];

export type AiMinimalIconProps = Omit<MinimalIconProps, 'name'> & {
  name: AiIconName;
};

export enum ArdoqIconCategory {
  Ardoq = 'Ardoq',
  BPMN = 'BPMN',
  ArchiMate = 'ArchiMate',
  EDGY = 'EDGY',
  FontAwesome = 'Font Awesome',
  Solution = 'Solution',
}

export type ArdoqIcon = {
  id: string;
  label: string;
  category: ArdoqIconCategory;
  isSVG?: boolean;
  scale?: { x: number; y: number };
};

export type ArdoqShape = {
  id: string;
  label: string;
  category?: ArdoqIconCategory;
  template?: string;
};

export type IconInfoForSvgImage =
  // args interpolation: ${iconId}~~${color}~~${fill}~~${stroke}~~${width}~~${height}~~${negativeColor}
  | `${string}~~${string}`
  | `${string}~~${string}~~${string}~~${string}~~${string}~~${string}`
  | `${string}~~${string}~~${string}~~${string}~~${string}~~${string}~~${string}`;

export enum ShapeType {
  DIAMOND = 'shape_DIAMOND',
  SQUARE = 'shape_SQUARE',
  CIRCLE = 'shape_CIRCLE',
  TRIANGLE = 'shape_TRIANGLE',
  PENTAGON = 'shape_PENTAGON',
  HOURGLASS = 'shape_HOURGLASS',
  QUATREFOIL = 'shape_QUATREFOIL',
}

export type Graphics = {
  shapes: Record<string, ArdoqShape>;
  icons: Record<string, ArdoqIcon>;
};

export type IsNegativeProps = {
  /** set this to true when the icon is being displayed as black or white atop a colored background. this removes the white from certain white-filled SVG icons. */
  isNegative?: boolean;
};

export type SvgIconName = IconName &
  (`svg_sprite_${string}` | `remix_${string}`);
type Standards = typeof standards;
export type StandardsSvgIcon = Standards[keyof Standards]['icon'] &
  (`bpmn-${string}` | `archimate-${string}` | `edgy-${string}`);
export type StandardsSvgShape = Exclude<
  Standards[keyof Standards]['shapeId'],
  '' | undefined | null
>;

export type SvgShapeSpriteName = ShapeType | StandardsSvgShape;
export type SvgIconSpriteName = SvgIconName | StandardsSvgIcon;
export type SvgSpriteName =
  | SvgIconSpriteName
  | SvgShapeSpriteName
  | SvgImageName;

export type ComponentTypeIconName = SvgIconSpriteName | FontAwesomeIconName;

export enum SpecialAssetTypeWithIcon {
  MANAGED_WORKSPACE = 'managed_workspace',
  IMAGE = 'image',
  DOCUMENT = 'document',
  UNKNOWN_FILE = 'unknown_file',
  FOLDER_OPENED = 'folder_opened',
}

export type EntityTypeWithIcon =
  | APIEntityType.COMPONENT
  | APIEntityType.COMPONENT_TYPE
  | APIEntityType.REFERENCE
  | APIEntityType.REFERENCE_TYPE;

export type AssetTypeWithIcon =
  | AssetType
  | UseCaseSpecificAssetType
  | SpecialAssetTypeWithIcon;

export type EntityAndAssetTypeWithIcon = AssetTypeWithIcon | EntityTypeWithIcon;
